import {
	clearCurrentTree,
	clearRehabTreesDefault,
	getRehabTreesList,
} from '@Actions';
import { selectIsLoading } from '@Selectors';
import { FullPage, FullPageWrapper } from '@Utils/styles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AGSList from '@Components/AGSetList';
import { useGlobalization } from '@Translations';

const AGSets = () => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearCurrentTree());
		dispatch(clearRehabTreesDefault());
		dispatch(getRehabTreesList());
		// dispatch(
		// 	getAssetCounts([
		// 		SystemTypes.SanitarySewer,
		// 		SystemTypes.WaterDistribution,
		// 	]),
		// );
	}, []);

	const isLoading = selectIsLoading();

	const agSetsTab = () => {
		return (
			<FullPage>
				<AGSList />
			</FullPage>
		);
	};

	const secondaryNav = () => {
		const tabs = [{ content: agSetsTab(), title: t('Asset Group Sets') }];

		return tabs;
	};

	return (
		<FullPageWrapper
			isLoading={isLoading}
			title={t('Asset Group Sets')}
			applyPadding={true}
			headerUnderline
			secondaryNav={{
				items: secondaryNav(),
				itemIndex: 0,
			}}></FullPageWrapper>
	);
};
export default AGSets;
